import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../context/AuthContext'
import CoordinatorLayout from '../components/CoordinatorLayout'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function CoordinatorMembers() {
  const { user } = useAuth()
  const [members, setMembers] = useState([])
  const [filtered, setFiltered] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const { data: coordinator } = await supabase
        .from('supporters').select('chapter_id').eq('id', user.id).single()

      if (!coordinator?.chapter_id) { setLoading(false); return }

      const { data } = await supabase
        .from('supporters').select('*').eq('chapter_id', coordinator.chapter_id)
        .order('joined_at', { ascending: false })

      if (data) { setMembers(data); setFiltered(data) }
      setLoading(false)
    }
    fetchData()
  }, [user])

  useEffect(() => {
    const results = members.filter((m) =>
      m.full_name.toLowerCase().includes(search.toLowerCase()) ||
      m.email.toLowerCase().includes(search.toLowerCase()) ||
      m.membership_id.toLowerCase().includes(search.toLowerCase())
    )
    setFiltered(results)
  }, [search, members])

  if (loading) return <LoadingSpinner fullScreen />

  return (
    <CoordinatorLayout>
      <div className="mb-6 lg:mb-8">
        <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">Members</h1>
        <p className="text-gray-500 text-sm">{members.length} members in your chapter</p>
      </div>

      {/* Search */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by name, email or ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 focus:border-green-600 text-gray-900 dark:text-white px-4 py-3 text-sm outline-none transition-colors w-full lg:max-w-md placeholder:text-gray-400 dark:placeholder:text-gray-600"
        />
      </div>

      {/* Members Table */}
      <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-black/20">
              {['Name', 'Membership ID', 'Email', 'Phone', 'Gender', 'Status'].map((h) => (
                <th key={h} className="text-left py-3 px-4 text-xs text-gray-500 uppercase tracking-widest font-semibold whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((member) => (
              <tr key={member.id} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                <td className="py-3 px-4 font-semibold whitespace-nowrap text-gray-900 dark:text-white">{member.full_name}</td>
                <td className="py-3 px-4 text-gray-500 text-xs font-mono whitespace-nowrap">{member.membership_id}</td>
                <td className="py-3 px-4 text-gray-500 text-xs">{member.email}</td>
                <td className="py-3 px-4 text-gray-500 text-xs">{member.phone}</td>
                <td className="py-3 px-4 text-gray-500 text-xs capitalize">{member.gender}</td>
                <td className="py-3 px-4">
                  <span className={`text-xs font-bold uppercase tracking-widest px-2 py-1 ${
                    member.status === 'active'
                      ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'
                      : 'bg-gray-200 dark:bg-white/10 text-gray-400'
                  }`}>
                    {member.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CoordinatorLayout>
  )
}